import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import NoMatchingAlert from 'components/fragments/NoMatchingAlert/NoMatchingAlert';
//import {ColumnHeader} from 'components/fragments/NoMatchingAlert/NoMatchingAlert';
const NoMatchingAlertComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/NoMatchingAlert/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <NoMatchingAlert {...props} />
  </ImagesProvider>
);

export default NoMatchingAlertComponent;
